import addTargetEventListener from '../events/addTargetEventListener';
import { selectors } from './elements/constants';
import * as eventsModel from './models/events';
import * as actionModel from './models/action';
import * as panelModel from './models/panel';

const attrEncode = str => str ? String(str).replace(/"/g, '&quot;') : '';

/**
 * Processes conditional inputs, i.e. converts them into hidden inputs.
 * @param {Event} action - The current action
 */
function buildInputs(action) {
  if(!action || !action.dataset.options) { return; }
  const options = JSON.parse(action.dataset.options);

  action.innerHTML = Object.entries(options).map(([key, value]) => (
    `<input type="hidden" name="${attrEncode(key)}" value="${attrEncode(value)}"/>`
  )).join('');
}

/**
 * Handled when this action goes 'out of view', i.e. hide panel.
 * @param {Event} event - The current event being handled
 */
function handleHideStep(event) {
  const action = actionModel.getAction(event.target);
  const { direction } = event.detail;

  // mark this action as 'complete' so that it can be queried for fields
  panelModel.updatePanelClasses(action, { active: false, complete: direction !== 'backwards' });
}

/**
 * Handled when this action comes 'into view', i.e. process any conditions and
 * dispatch navigation event.
 * @param {Event} event - The current event being handled
 */
function handleShowStep(event) {
  const action = actionModel.getAction(event.target);

  // mark this action as 'active' so that it can be queried for fields
  panelModel.updatePanelClasses(action, { active: true, complete: false });

  if(actionModel.conditionsMet(action)) {
    // the action conditions are met, so do processing
    buildInputs(action);
  } else {
    action.innerHTML = '';
  }

  eventsModel.dispatchNavigateEvent(event.target);
}

addTargetEventListener(eventsModel.events.showStep, selectors.actionFormOption, handleShowStep);
addTargetEventListener(eventsModel.events.hideStep, selectors.actionFormOption, handleHideStep);
